// extracted by mini-css-extract-plugin
module.exports = {"hd":"_2950","message":"_18030","action":"_13579"};